<template>
    <div>
        <limitless-page-header :title="'Dokument'">
            <template #header-elements>
                <limitless-page-header-button v-if="hasPermission('red_edit_document_categories')" url="/documents/categories" icon="icon-folder6">Kategorier</limitless-page-header-button>
                <limitless-page-header-button v-if="hasPermission('red_edit_documents')" url="/documents/upload" icon="icon-file-upload">Ladda upp flera</limitless-page-header-button>
                <limitless-page-header-button v-if="hasPermission('red_edit_documents')" url="/documents/new" icon="icon-plus3">Nytt dokument</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <rednax-datatable :url="'/vue/documents/table'" :columns="table_columns" :filter="table_filter" @updateFilter="table_filter=$event" sort-by="created_at" sort-order="desc" @rowclick="rowClick" history>
                <div class="row">
                    <div class="col-lg-3">
                        <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                    </div>
                    <div class="col-lg-3">
                        <v-select
                            v-model="table_filter.document_category_id"
                            :options="categories"
                            label="name"
                            :reduce="item => item.id"
                            placeholder="-- Alla kategorier --"
                        />
                    </div>
                </div>
            </rednax-datatable>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';
import vSelect from 'vue-select';
import { hasPermission } from '@services/Helpers';
import apiClient from '@services/ApiClient';

export default {
    name: 'DocumentList',
    components: {
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        RednaxDatatable,
        vSelect,
    },
    data: () => ({
        categories: [],
        table_filter: {
            search: '',
            document_category_id: '',
        },
        table_columns: [
            {
                header: 'Namn',
                data: 'name',
                sortable: true,
                render(row) {
                    return '<i class="icon-file-' + row.extension + ' mr-2"></i>' + row.name;
                },
            },
            {
                header: 'Filtyp',
                data: 'extension',
                sortable: true,
            },
            {
                header: 'Skapad',
                data: 'created_at',
                sortable: true,
            },
            {
                header: 'Uppdaterad',
                data: 'updated_at',
                sortable: true,
            },
            {
                header: '',
                data: 'uuid',
                sortable: true,
                render(row) {
                    let html = '';
                    html = '<a class="btn btn-light" href="/documents/download/' + row.uuid + '"><i class="icon-file-download mr-2"></i>Ladda ner</a>';
                    return html;
                },
            },
        ],
    }),
    mounted() {
        this.getCategories();
    },
    methods: {
        hasPermission,
        rowClick(data) {
            if (this.hasPermission('red_edit_documents')) {
                window.location.href = '/documents/' + data.uuid;
            }
        },
        getCategories() {
            apiClient.get('/vue/documents/categories/table').then((res) => {
                this.categories = res.data.data;
            });
        },
    },
};

</script>
